module.exports = __webpack_public_path__ + "static/th-71b4ecfde970aea7f2f85e6e35fe5959.png";